import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ROUTES } from '../config/app.config';

/**
 * For login/forgot/reset: redirect to app (e.g. dashboard) if already logged in.
 */
export function PublicRoute({ children, redirectTo }) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();
  
  // Determine default redirect based on user role
  // Sellers (shop_manager) should go to stock page, admins to dashboard
  const getDefaultRoute = () => {
    if (user) {
      const userRole = user?.role?.toUpperCase?.() || user?.role || '';
      const userRoles = user?.roles || [];
      const roleArray = Array.isArray(userRoles) ? userRoles.map(r => String(r).toUpperCase()) : [];
      
      // Check if user is seller/manager (shop_manager) - they should go to stock
      const isSeller = userRole === 'SHOP_MANAGER' || 
                      userRole === 'MANAGER' ||
                      roleArray.includes('SHOP_MANAGER') ||
                      roleArray.includes('MANAGER');
      
      if (isSeller) {
        return ROUTES.STOCK;
      }
    }
    return ROUTES.DASHBOARD;
  };
  
  const to = redirectTo || location?.state?.from?.pathname || getDefaultRoute();

  if (isLoading) return null;

  if (isAuthenticated) {
    return <Navigate to={to} replace />;
  }

  return children;
}
